<script>
export let form;

import { Navigate } from 'svelte-router-spa';

</script>


<style>

.form-card {

}

.card-content {
	padding: 1rem 1rem !important;
}

.form-name {
	/*margin-bottom: 0.175rem;*/
	font-size: 1.175rem;
	color: #1f1f1f;
	text-align: center;
}

</style>



<Navigate styles="card form-card" to="/form/{form.id}">

	<div class="card-content">

		<p class="form-name">
			{form.name}
		</p>

	</div>

</Navigate>

